import React from "react";
import { DeliveryInfo } from "@checkout-core/interfaces/DeliveryInfo";

export interface DeliveryInfoContextValue {
    deliverySelectedSlot: DeliveryInfo;
    setDeliverySelectedSlot: (deliverySelectedSlot: DeliveryInfo) => void;
}

const INIT_STATE = {
    deliveryTimeAnnotation: "",
    deliveryTime: "",
};

export const DeliveryInfoContext = React.createContext<DeliveryInfoContextValue>({
    deliverySelectedSlot: INIT_STATE,
    setDeliverySelectedSlot: _deliverySelectedSlot => void 0,
});

if (__DEV__) {
    DeliveryInfoContext.displayName = "DeliveryInfoContext";
}
